
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/profile/[slug]",
      function () {
        return require("private-next-pages/[market]/[language]/profile/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/profile/[slug]"])
      });
    }
  